import { array, func, string } from 'prop-types'
import { Component } from 'react'
import { kuiperClassNames, Menu, PopoverV2, renderIcon } from '@opallabs/kuiper'
import { isInWorkflowPopover } from '../../helpers/matchers'

import './styles.scss'

class UnassignedApproval extends Component {
  static propTypes = {
    onSelectAssignee: func,
    people: array,
    workflowLocation: string,
  }

  constructor(props) {
    super(props)
    this.state = {
      isUsingKeyboard: false,
    }
  }

  focusInput() {
    this.content.querySelector('input.kuiper-input-element').focus()
  }

  handleKeyPress = (e) => {
    e.stopPropagation()
    switch (e.which) {
      case 13:
        this.onEnterPressed()
        break
      default:
        break
    }
  }

  handleSearchKeyPress = (e) => {
    e.stopPropagation()
    switch (e.which) {
      case 27:
        this.onEscapePressed()
        break
      default:
        break
    }
  }

  onEnterPressed = () => {
    this.setState(
      () => ({ isUsingKeyboard: true }),
      () => {
        this.trigger.click()
      }
    )
  }

  onEscapePressed() {
    if (this.state.isUsingKeyboard) {
      this.trigger.focus()
    }
  }

  popoverContent() {
    return (
      <Menu
        avatared={true}
        options={this.props.people}
        onSearchKeyDown={this.handleSearchKeyPress}
        onSelect={this.props.onSelectAssignee}
        role="listbox"
        searchable={true}
        searchIcon="plus"
        searchIconSize={8}
      />
    )
  }

  popoverTrigger = () => (
    /* eslint-disable jsx-a11y/no-noninteractive-tabindex, jsx-a11y/no-static-element-interactions */
    <div
      className={kuiperClassNames('unassignedApproval')}
      ref={(trigger) => (this.trigger = trigger)}
      onKeyPress={this.handleKeyPress}
      tabIndex={0}
    >
      <div
        className={kuiperClassNames('unassignedApproval-innerWrapper')}
        tabIndex={-1}
      >
        <div className={kuiperClassNames('unassignedApproval-icon')}>
          {renderIcon('plus', {
            height: 10,
            width: 10,
            ariaLabel: 'Assign an approver',
            ariaMode: 'presentational',
          })}
        </div>
        <div className={kuiperClassNames('full-name')}>Approver Unassigned</div>
      </div>
    </div>
    /* eslint-enable jsx-a11y/no-noninteractive-tabindex, jsx-a11y/no-static-element-interactions */
  )

  render() {
    if (isInWorkflowPopover(this.props.workflowLocation)) {
      return (
        <div className={kuiperClassNames('unassignedApproval', 'disabled')}>
          <div className={kuiperClassNames('unassignedApproval-avatar')} />
          <div className={kuiperClassNames('full-name')}>
            Approver Unassigned
          </div>
        </div>
      )
    }

    return (
      <PopoverV2
        className={kuiperClassNames('user-picker-popover', 'no-padding')}
        content={this.popoverContent()}
        onOpened={this.focusInput}
        position="bottom"
        trigger={this.popoverTrigger()}
      />
    )
  }
}

export default UnassignedApproval
